<template>
  <a-table
    :columns="columns"
    :data-source="list"
    bordered
    rowKey="id"
    :pagination="false"
    :loading="loading"
    size="small"
  >
    <!-- 类型 -->
    <template slot="updateType" slot-scope="text">
      <!-- 0-新建，1-编辑，2-删除，3-禁用，4-重新启用   -->
      <span v-for="item in $t('com_operationTypes')" :key="item.value">
        <span v-if="text === item.value">{{ item.name }}</span>
      </span>
    </template>

    <template slot="devId" slot-scope="text">
      <div class="g-table-text">
        {{ text }}
      </div>
    </template>
    <template slot="devName" slot-scope="text">
      <div class="g-table-text">
        {{ text }}
      </div>
    </template>

    <!-- executeStartTime -->
    <template slot="executeStartTime" slot-scope="text">
      {{ text | formatDate }}
    </template>

    <!-- executeStartTime -->
    <template slot="executeEndTime" slot-scope="text">
      {{ text | formatDate }}
    </template>

    <!-- operationType -->
    <template slot="executeResult" slot-scope="text">
      <!-- 执行结果，0-执行失败，1-执行成功，2-执行超时 -->
      <span v-if="text === 0">{{ $t('com_msg_fail') }}</span>
      <span v-else-if="text === 1">{{ $t('com_msg_success') }}</span>
      <span v-else-if="text === 2">{{ $t('com_msg_timeout') }}</span>
    </template>

    <!-- 执行数据 -->
    <template slot="executeData" slot-scope="text, record">
      <div class="g-table-text">
        <a-icon
          type="copy"
          data-clipboard-action="copy"
          title="Copy"
          style="color:#ccc"
          :data-clipboard-text="`${text}`"
          :id="`logs_device_command_event_${record.id}`"
          @click="copyContent(`#logs_device_command_event_${record.id}`)"
        />{{ text }}
      </div>
    </template>

    <!-- operationType -->
    <template slot="operationType" slot-scope="text">
      <span v-for="item in $t('com_operationTypes')" :key="item.value">
        <span v-if="text === item.value">{{ item.name }}</span>
      </span>
    </template>
  </a-table>
</template>
<script>
import { copyContent } from '@/libs/utils';

export default {
  props: {
    list: {
      type: [Array, Object],
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      copyContent,
      columns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          dataIndex: 'id',
        },
        {
          title: this.$t('logs_table_device_id'),
          dataIndex: 'devId',
          scopedSlots: { customRender: 'devId' },
        },
        {
          title: this.$t('logs_table_device_name'),
          dataIndex: 'devName',
          scopedSlots: { customRender: 'devName' },
        },

        {
          title: this.$t('com_table_type'),
          dataIndex: 'operationType',
          scopedSlots: { customRender: 'operationType' },
        },

        {
          title: this.$t('logs_table_data'),
          dataIndex: 'executeData',
          scopedSlots: { customRender: 'executeData' },
        },

        {
          title: this.$t('logs_table_execute_start_time'),
          dataIndex: 'executeStartTime',
          scopedSlots: { customRender: 'executeStartTime' },
        },

        {
          title: this.$t('logs_table_execute_end_time'),
          dataIndex: 'executeEndTime',
          scopedSlots: { customRender: 'executeEndTime' },
        },

        {
          title: this.$t('logs_table_execute_end_result'),
          dataIndex: 'executeResult',
          scopedSlots: { customRender: 'executeResult' },
        },
      ],
    };
  },
};
</script>
